import React, { useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import HubPage from "./pages/HubPage";
import ServicePage from "./pages/ServicePage";
import Contact from "./pages/Contact";
import About from "./pages/About";
import HowItWorks from "./pages/HowItWorks";
import EligibilityQuiz from "./pages/EligibilityQuiz";
import BookConsultation from "./pages/BookConsultation";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";
import Disclaimer from "./pages/Disclaimer";
import Placeholder from "./pages/Placeholder";
import { serviceGroups } from "./data/services";
import { captureUtm } from "./config/maraApi";

export default function App() {
  // First-touch UTM capture on load (D-008 / lead attribution).
  useEffect(() => {
    captureUtm();
  }, []);

  return (
    <>
      <ScrollToTop />
      <Header />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/contact/" element={<Contact />} />
          <Route path="/about/" element={<About />} />
          <Route path="/how-it-works/" element={<HowItWorks />} />
          <Route path="/eligibility-quiz/" element={<EligibilityQuiz />} />
          <Route path="/book-consultation/" element={<BookConsultation />} />
          <Route path="/privacy-policy/" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service/" element={<TermsOfService />} />
          <Route path="/disclaimer/" element={<Disclaimer />} />

          {/* Hub + service routes generated from the registry (D-001).
              A service with no content file renders a "coming soon" stub. */}
          {serviceGroups.map((g) => (
            <React.Fragment key={g.slug}>
              <Route
                path={`/${g.slug}/`}
                element={<HubPage groupSlug={g.slug} />}
              />
              {g.services.map((s) => (
                <Route
                  key={s.slug}
                  path={`/${g.slug}/${s.slug}/`}
                  element={
                    <ServicePage groupSlug={g.slug} serviceSlug={s.slug} />
                  }
                />
              ))}
            </React.Fragment>
          ))}

          {/* Remaining pages (quiz, booking, trust, legal) are stubbed
              until their build phases. */}
          <Route path="*" element={<Placeholder />} />
        </Routes>
      </main>
      <Footer />
    </>
  );
}
